import React from 'react';
import { getToken, onMessageListener } from '../firebase';
import QRCode from 'qrcode.react';

export default class App extends React.Component {

  state = {}

  componentDidMount() {
    getToken((token) => {
      this.setState({ token });
    });
    onMessageListener().then(payload => {
      console.log(payload);
    });
  }

  render() {
    return (
      <div>
        import QRCode from '../../others/QRCode';
      </div>
    );
  }

}